import axios from "axios";
import { showError } from "./toastUtils";

const UPLOAD_URL = `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_NAME}/upload`;
const UPLOAD_PRESET = process.env.REACT_APP_UPLOAD_PRESET;
const MAX_FILE_SIZE_MB = Number(process.env.REACT_APP_MAX_FILE_SIZE_MB) || 20;
const MAX_IMAGE_SIZE_MB = 10;

const uploadFileToCloudinary = (file, onProgress = () => {}) => {
  if (!file) return Promise.reject(new Error("No file provided"));

  const fileSizeMB = file.size / (1024 * 1024);

  if (file.type.startsWith("image/") && fileSizeMB > MAX_IMAGE_SIZE_MB) {
    showError("Image is too large (max 10MB)");
    console.error("Image is too large (max 10MB)");
  }

  if (fileSizeMB > MAX_FILE_SIZE_MB) {
    showError(
      `File too large. Max allowed size is ${MAX_FILE_SIZE_MB}MB`
    );
  }

  const allowedTypes = ["image/", "video/"];

  const isAllowed = allowedTypes.some((type) => file.type.startsWith(type));
  if (!isAllowed) {
    console.warn("File type not explicitly allowed:", file.type);
    return Promise.reject(new Error("Unsupported file type"));
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", UPLOAD_PRESET);

  //AUTO DETECT FILE TYPE
  let resourceType = "image";
  if (file.type.startsWith("video/")) resourceType = "video";
  if (file.type === "application/pdf") resourceType = "auto";

  const controller = new AbortController();

  const uploadPromise = axios
    .post(
      `${UPLOAD_URL.replace("/auto/upload", `/${resourceType}/upload`)}`,
      formData,
      {
        signal: controller.signal,
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            onProgress(percent);
          }
        },
      }
    )
    .then((res) => ({
      url: res.data.secure_url,
      public_id: res.data.public_id,
      resource_type: res.data.resource_type,
    }))
    .catch((err) => {
      if (axios.isCancel(err)) {
        console.error("Upload cancelled by user");
        showError("Upload cancelled by user");
      }
      console.error(err.message || "Upload failed");
      showError(err.message || "Upload failed");
      return null;
    });

  return { uploadPromise, cancel: () => controller.abort() };
};

export default uploadFileToCloudinary;
